$(() => {
  $('<button type="button" class="scroll-footer-down-btn">Scroll</button>').appendTo('.bs-section--talk-to-your-pharmacist');
  $('<button type="button" class="scroll-footer-down-btn">Scroll</button>').appendTo('.bs-section--scroll-footer-down-btn');

  // hide footer scroll btn on orientation change
  $(window).on('orientationchange', function () {
    $(window).one('resize', function() {
      setTimeout(function () {
        let footer = $('footer').get(0).getBoundingClientRect();
        let windowHeight = $(window).height();
        if (footer.bottom < (windowHeight + footer.height)) {
          $('.scroll-footer-down-btn').css('display','none');
        }
      }, 10)
    });
  })
});